import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"
import CustomRewardFragment from "../fragment/CustomReward"

const query = gql`
  query CustomRewards($uuid: ID!) {
    customReward(uuid: $uuid) {
      ...CustomReward
    }
  }

  ${CustomRewardFragment}
`
export const getCustomRewardQueryKey = getQueryNames(query)[0]
export default query
